import { IInitializeStorection } from '../../store/types'

export interface ISnackbarState {
  /**
   Message to be shown
   */
  message: string
  /**
   * Type of toast.
   * @default success
   */
  severity: Severity
  /**
   * Time (ms)
   *  @default 4000
   */
  time: number
  /**
   * Is toast open
   */
  isOpen: boolean
}

export type Severity = 'info' | 'success' | 'warning' | 'error'

export const OPEN_SNACKBAR = 'snackbar/OPEN_SNACKBAR'
export const CLOSE_SNACKBAR = 'snackbar/CLOSE_SNACKBAR'

export interface IOpenSnackbarAction {
  type: typeof OPEN_SNACKBAR
  message: string
  severity: Severity
  time: number
}

export interface ICloseSnackbarAction {
  type: typeof CLOSE_SNACKBAR
}

export type SnackbarActionTypes =
  | IInitializeStorection
  | IOpenSnackbarAction
  | ICloseSnackbarAction
